import { debounce } from '../utils/_debounce'
import ObjectFit from './_object-fit'

export default class LazyLoad {
  constructor () {
    setTimeout(() => {
      this.videosLazyLoaded = false
      window.addEventListener('load', () => this.lazyLoadVideos())
      window.addEventListener('resize', debounce(() => this.lazyLoadVideos(), 300))
    }, 10)

    const ua = window.navigator.userAgent
    const msie = ua.indexOf('Trident')
    if (msie > 0) // If Internet Explorer, return true
    {
      this.ieResolve(document.querySelectorAll('[lazy-load]'))
      return true
    }

    this.ieResolve(document.querySelectorAll('[critical]'))
    
    this.resolveLazyLoad(document.querySelectorAll('[lazy-load]'))

    window.addEventListener('scroll', () => {
      this.resolveLazyLoad(document.querySelectorAll('[lazy-load]'))
    })

    window.addEventListener('click', () => {
      this.resolveLazyLoad(document.querySelectorAll('[lazy-load]'))
    })
  }

  isScrolledIntoView (elem) {
    const docViewTop = window.scrollY
    const elemTop = elem.getBoundingClientRect().top + document.body.scrollTop - 1000

    return (elemTop <= docViewTop)
  }

  ieResolve (lazyElements) {
    Array.prototype.forEach.call(lazyElements, (item) => {
      item.setAttribute('lazy-loaded', 'true')
      const fullSize = item.getAttribute('data-full')
        ? item.getAttribute('data-full')
        : item.getAttribute('src')

      const preload = new Image()
      preload.onload = () => {
        if (item.tagName === 'SOURCE') {
          item.setAttribute('srcset', fullSize)
        } else {
          item.setAttribute('src', fullSize)
        }
        item.removeAttribute('lazy-load')
      }
      preload.src = fullSize
    })
  }

  resolveLazyLoad (lazyElements) {
    Array.prototype.forEach.call(lazyElements, (item) => {
      if (this.isScrolledIntoView(item) && !item.getAttribute('lazy-loaded') && item.offsetParent !== null ||
            item.getAttribute('afterload') && !item.getAttribute('lazy-loaded') && item.offsetParent !== null) {
        item.setAttribute('lazy-loaded', 'true')
        item.removeAttribute('lazy-load')

        const fullSize = item.getAttribute('data-full')
          ? item.getAttribute('data-full')
          : item.getAttribute('src')
        const srcsetfull = item.getAttribute('srcsetfull')

        const cssbg = item.getAttribute('cssbg')

        if (cssbg) {
          item.style.backgroundImage = 'url(' + cssbg + ')'
        } else if (fullSize) {
          if (srcsetfull) {
            item.setAttribute('srcset', srcsetfull)
          }
          if (item.tagName === 'SOURCE') {
            item.setAttribute('srcset', fullSize)
          } else {
            item.setAttribute('src', fullSize)
          }
        }
      }
    })
  }

  lazyLoadVideos () {
    // only lazyload videos for tablet and above
    if (!this.videosLazyLoaded && this.getScreenWidth() > 760) {
      this.videosLazyLoaded = true

      const TARGETS = document.querySelectorAll('[data-lazy-video]')
      if (TARGETS.length > 0) {
        for (let i = 0; i < TARGETS.length; i++) {
          this.lazyLoadVideo(TARGETS[i])
        }
      }
    }
  }

  lazyLoadVideo (TARGET) {
    if (!TARGET) return

    const data = {
      action: 'lazy_load_video',
      video_url: TARGET.getAttribute('data-lazy-video')
    }

    jQuery.post(main_theme_objects.ajax_url, data,
      (response) => {
        if (response !== 0) {
          TARGET.innerHTML = response.markup
          TARGET.setAttribute('data-lazy-video', true)
          ObjectFit()
        }
      }
    )
  }

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }
}
